class SearchCharitiesFront {
  constructor() {
    this.searchCharityIcon = document.querySelector(".searchCharityIcon")
    this.searchCharityInput = document.querySelector(".searchCharityInput")

    //===================================
    // Animation search input front page  
    if (this.searchCharityInput) {
      this.typingTimer


      // TEXT ROTATOR SEARCH BAR
      var TxtType = function (el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 5) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
      };

      TxtType.prototype.tick = function () {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
          this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
          this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.placeholder = this.txt + '|';

        var that = this;
        var delta = 200 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
          delta = this.period;
          this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
          this.isDeleting = false;
          this.loopNum++;
          delta = 500;
        }

        setTimeout(function () {
          that.tick();
        }, delta);
      };

      window.onload = function () {
        var elements = document.getElementsByClassName('searchCharityInput');

        for (var i = 0; i < elements.length; i++) {
          var toRotate = elements[i].getAttribute('data-type');
          var period = elements[i].getAttribute('data-period');

          if (toRotate) {
            new TxtType(elements[i], JSON.parse(toRotate), period);
          }
        }
      };
    }
    //===================================
    this.events()
  }

  events() {
    if (document.querySelector('.home')) {
      this.searchCharityIcon.addEventListener("click", () => this.searchCharities())
      document.addEventListener("keydown", e => {
        if (e.which == 13 || e.keyCode == 13) {
          this.searchCharities()
        }
      })
    }
  }

  searchCharities() {
    if (this.searchCharityInput.value.length < 2) {
      console.log('Oups need the name of a place or postcode')
    } else {
      document.cookie = "place=" + this.searchCharityInput.value
      window.location = charitiesData.root_url + '/your-charities'
    }
  }

}

export default SearchCharitiesFront